import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs'; // Choose your preferred style
import emailjs from 'emailjs-com';
import Donut from 'react-spinning-donut';



const ContactForm = () => {
	const [formData, setFormData] = useState({
		name: '',
		email: '',
		subject: '',
		message: ''
	});


	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevData) => ({ ...prevData, [name]: value }));
	};

	const today = new Date();
	const dd = String(today.getDate()).padStart(2, '0');
	const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
	const yyyy = today.getFullYear();
	const currentDate = `${dd}-${mm}-${yyyy}`;


const codeString = `const button = document.querySelector('#sendBtn');

const message = {
	name: "${formData.name}",
	email: "${formData.email}",
	subject: "${formData.subject}",
	message: "${formData.message}",
	date: "${currentDate}"
};

button.addEventListener('click', () => {
	form.send(message);
});`;

	const SERVICE_ID = process.env.REACT_APP_SERVICE_ID;
	const TEMPLATE_ID = process.env.REACT_APP_TEMPLATE_ID;
	const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY;

	const sendEmail = (e) => {
		e.preventDefault();

		const templateParams = {
			from_name: formData.name,
			from_email: formData.email,
			subject: formData.subject,
			message: formData.message
		};

		emailjs.send(
			SERVICE_ID, // replace with your EmailJS service ID
			TEMPLATE_ID, // replace with your EmailJS template ID
			templateParams,
			PUBLIC_KEY // replace with your EmailJS user ID
		)
		.then((response) => {
			alert('Thanks for connecting! I will get back to you as soon as possible');

			setFormData({
				name: '',
				email: '',
				subject: '',
				message: ''
			});
		})
		.catch((error) => {
			console.log('FAILED...', error);
			alert('Failed to send the message. Please try again.');
		});

	};

	

	return (
		<div className='min-h-screen flex  md:flex-col'>
			<div className="flex flex-col flex-1">
				<motion.div
					className='flex-1 m-4'
					initial="hidden"
					whileInView="visible"
					viewport={{ once: false }}
					transition={{ duration: 0.5 }}
					variants={{
						hidden: { opacity: 0, x: -100 },
						visible: { opacity: 1, x: 0 },
					}}
				>
					<div  
						className="contactformheader mb-10"
					>
						<p className="font-bold">{`>./message`}</p>
						<p className="font-bold text-5xl mt-3">Let's <br /> Connect.</p>
						<p className='text-sm mt-3 text-gray-300'>{`// Leave me a message`}</p>
					</div>

					<form 
						onSubmit={sendEmail} 
						className="space-y-6" 
						autoComplete="off"
					>
						<div className='mt-5'>
							<label htmlFor="name" className="block text-sm font-semibold text-gray-200">
								{`>. `}Name
							</label>
							<input
								type="text"
								name="name"
								id="name"
								value={formData.name}
								onChange={handleChange}
								placeholder='// John Doe'
								required
							/>
						</div>
						<div className='mt-5'>
							<label htmlFor="email" className="block text-sm font-semibold text-gray-200">
								{`>. `}Email 
							</label>
							<input
								type="email"
								name="email"
								id="email"
								value={formData.email}
								onChange={handleChange}
								placeholder='// johndoe@email.com'
								required
							/>
						</div>
						<div className='mt-5'>
							<label htmlFor="subject" className="block text-sm font-semibold text-gray-200">
								{`>. `}Subject
							</label>
							<input
								type="text"
								name="subject"
								id="subject"
								value={formData.subject}
								onChange={handleChange}
								placeholder='// What is this message about?'
								required
							/>
						</div>
						<div className='mt-5'>
							<label htmlFor="message" className="block text-sm font-semibold text-gray-200">
								{`>. `}Message
							</label>
							<textarea
								name="message"
								id="message"
								rows="7"
								value={formData.message}
								onChange={handleChange}
								placeholder='// Type your message here...'
								required
							/>
						</div>
						<button type='submit' className="btn">{`>.  `}Send Message</button>
				</form>
				</motion.div>
			</div>
			<div className="flex flex-col items-center">
				<motion.div
				className='m-4 md:hidden'
				initial="hidden"
				whileInView="visible"
				viewport={{ once: false }}
				transition={{ duration: 0.5 }}
				variants={{
					hidden: { opacity: 0, x: 100 },
					visible: { opacity: 1, x: 0 },
				}}
				>
					<div style={{border: "1px solid #3d3d3d"}} className="codecontainer rounded-2xl overflow-hidden max-w-md">
						<div style={{background: "#1d1d1d", borderBottom: "1px solid #3d3d3d"}} className="containermet flex justify-between items-center p-4 pt-3 pb-2">
							<div className="containername text-sm">{`>. `}sendMessage.js</div>
							<div className="containerbtns flex">
								<div className="contbtn size-3 rounded-xl bg-green-500 mr-1" />
								<div className="contbtn size-3 rounded-xl bg-yellow-500 mr-1" />
								<div className="contbtn size-3 rounded-xl bg-red-500" />
							</div>
						</div>
						<SyntaxHighlighter 
							showLineNumbers={true} 
							language="javascript" 
							style={atomOneDark}
							customStyle={{
								backgroundColor: "transparent",
								opacity: "1",
								maxWidth: '500px'
							}}
						>
							{codeString}
						</SyntaxHighlighter>
					</div>
				</motion.div>

				<motion.div
				className='sm:mt-4'
					initial="hidden"
					whileInView="visible"
					viewport={{ once: false }}
					transition={{ duration: 0.5 }}
					variants={{
						hidden: { opacity: 0, x: 100 },
						visible: { opacity: 1, x: 0 },
					}}
				>
					<Donut color="#ccc" />
				</motion.div>

			</div>
		</div>
	);
};

export default ContactForm;
